import React from 'react';

const CookiesPolicy = () => {
  return (
    <div className="font-sans bg-ink text-white">
      {/* Hero Section */}
      <section className="panel-surface text-white section-padding font-display">
        <div className="container-custom text-center">
          <h1 className="text-5xl font-display font-bold mb-6">
            Cookies Policy
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto font-sans">
            Learn how we use cookies and similar technologies to enhance your experience on IBT Sports.
          </p>
          <div className="mt-6">
            <div className="badge-official">Last Updated: December 2024</div>
          </div>
        </div>
      </section>

      {/* Policy Content */}
      <section className="section-padding">
        <div className="container-custom max-w-4xl">
          <div className="space-y-12">
            
            {/* Introduction */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                What Are Cookies?
              </h2>
              <div className="space-y-4 text-gray-300 font-sans leading-relaxed">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>
                <p>
                  Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
                  Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
              </div>
            </div>

            {/* Types of Cookies */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Types of Cookies We Use
              </h2>
              <div className="space-y-8">
                
                {/* Essential Cookies */}
                <div className="panel-surface p-6 rounded-lg">
                  <div className="flex items-start">
                    <div className="w-10 h-10 bg-gradient-to-br from-primary to-accent-warm rounded-lg flex items-center justify-center mr-4">
                      <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-semibold text-white mb-3 font-display">Essential Cookies</h3>
                      <p className="text-gray-300 font-sans mb-4">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. These cookies are necessary for the website to function properly.
                      </p>
                      <div className="space-y-2">
                        <div className="flex items-center text-sm text-gray-300">
                          <div className="w-2 h-2 bg-primary rounded-full mr-3"></div>
                          Session management and security
                        </div>
                        <div className="flex items-center text-sm text-gray-300">
                          <div className="w-2 h-2 bg-primary rounded-full mr-3"></div>
                          User authentication
                        </div>
                        <div className="flex items-center text-sm text-gray-300">
                          <div className="w-2 h-2 bg-primary rounded-full mr-3"></div>
                          Shopping cart functionality
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Analytics Cookies */}
                <div className="panel-surface p-6 rounded-lg">
                  <div className="flex items-start">
                    <div className="w-10 h-10 bg-gradient-to-br from-accent-warm to-primary rounded-lg flex items-center justify-center mr-4">
                      <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z"/>
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-semibold text-white mb-3 font-display">Analytics Cookies</h3>
                      <p className="text-gray-300 font-sans mb-4">
                        Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. These help us understand how visitors interact with our site.
                      </p>
                      <div className="space-y-2">
                        <div className="flex items-center text-sm text-gray-300">
                          <div className="w-2 h-2 bg-accent-warm rounded-full mr-3"></div>
                          Page views and user behavior
                        </div>
                        <div className="flex items-center text-sm text-gray-300">
                          <div className="w-2 h-2 bg-accent-warm rounded-full mr-3"></div>
                          Performance monitoring
                        </div>
                        <div className="flex items-center text-sm text-gray-300">
                          <div className="w-2 h-2 bg-accent-warm rounded-full mr-3"></div>
                          Error tracking and debugging
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Marketing Cookies */}
                <div className="panel-surface p-6 rounded-lg">
                  <div className="flex items-start">
                    <div className="w-10 h-10 bg-gradient-to-br from-accent-success to-primary rounded-lg flex items-center justify-center mr-4">
                      <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z"/>
                      </svg>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-semibold text-white mb-3 font-display">Marketing Cookies</h3>
                      <p className="text-gray-300 font-sans mb-4">
                        Ut enim ad minim veniam, quis nostrud exercitation. These cookies are used to deliver relevant advertisements.
                      </p>
                      <div className="space-y-2">
                        <div className="flex items-center text-sm text-gray-300">
                          <div className="w-2 h-2 bg-accent-success rounded-full mr-3"></div>
                          Personalized advertising
                        </div>
                        <div className="flex items-center text-sm text-gray-300">
                          <div className="w-2 h-2 bg-accent-success rounded-full mr-3"></div>
                          Social media integration
                        </div>
                        <div className="flex items-center text-sm text-gray-300">
                          <div className="w-2 h-2 bg-accent-success rounded-full mr-3"></div>
                          Campaign tracking
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Cookie Management */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Managing Your Cookie Preferences
              </h2>
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <h3 className="text-xl font-semibold text-white font-display">Browser Settings</h3>
                    <div className="space-y-3 text-gray-300 font-sans">
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit:</p>
                      <ul className="space-y-2 ml-6">
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-primary rounded-full mr-3 mt-2"></div>
                          Chrome: Settings → Privacy and Security → Cookies
                        </li>
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-primary rounded-full mr-3 mt-2"></div>
                          Firefox: Options → Privacy & Security → Cookies
                        </li>
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-primary rounded-full mr-3 mt-2"></div>
                          Safari: Preferences → Privacy → Cookies
                        </li>
                      </ul>
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <h3 className="text-xl font-semibold text-white font-display">Cookie Consent</h3>
                    <div className="space-y-3 text-gray-300 font-sans">
                      <p>Sed do eiusmod tempor incididunt ut labore et dolore:</p>
                      <ul className="space-y-2 ml-6">
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-accent-warm rounded-full mr-3 mt-2"></div>
                          Accept all cookies
                        </li>
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-accent-warm rounded-full mr-3 mt-2"></div>
                          Reject non-essential cookies
                        </li>
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-accent-warm rounded-full mr-3 mt-2"></div>
                          Customize preferences
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Third-Party Cookies */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Third-Party Cookies
              </h2>
              <div className="space-y-4 text-gray-300 font-sans leading-relaxed">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
                  {[
                    { name: "Google Analytics", purpose: "Website analytics and performance monitoring" },
                    { name: "Facebook Pixel", purpose: "Social media advertising and tracking" },
                    { name: "Stripe", purpose: "Payment processing and security" }
                  ].map((service, index) => (
                    <div key={index} className="panel-surface p-4 rounded-lg">
                      <h4 className="font-semibold text-white mb-2 font-display">{service.name}</h4>
                      <p className="text-sm text-gray-300 font-sans">{service.purpose}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Updates to Policy */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Updates to This Policy
              </h2>
              <div className="space-y-4 text-gray-300 font-sans leading-relaxed">
                <p>
                  Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
                  Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>
              </div>
            </div>

            {/* Contact Information */}
            <div className="card-glass p-8">
              <h2 className="text-3xl font-display font-bold text-white mb-6">
                Contact Us
              </h2>
              <div className="space-y-4 text-gray-300 font-sans">
                <p>
                  If you have any questions about our use of cookies, please contact us:
                </p>
                <div className="space-y-2">
                  <p><strong className="text-white">Email:</strong> privacy@ibtsports.com</p>
                  <p><strong className="text-white">Phone:</strong> +1 (800) IBT-SPORT</p>
                  <p><strong className="text-white">Address:</strong> 123 Sports Avenue, Suite 500, New York, NY 10001</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiesPolicy;
